import { UnitUsage } from "models/UnitUsage";

export class Unit {
    id: number;
    short: string;
    name: string;
    unitUsages: UnitUsage[];
    archivedDate?: Date;

    constructor(
        id: number,
        short: string,
        name: string,
        unitUsages: UnitUsage[],
        archivedDate?: Date
    ) {
        this.id = id;
        this.short = short;
        this.name = name;
        this.unitUsages = unitUsages;
        this.archivedDate = archivedDate;
    }

    static empty(): Unit {
        return { id: 0, short: '', name: '', unitUsages:[]};
    }
    static newEmpty(uu: UnitUsage[]): Unit {
        return { id: 0, short: '', name: '', unitUsages: uu};
    }
    static hasUsage(unit: Unit, usageType: string): boolean {
        return unit.unitUsages?.some(uu => uu.unitUsageType.name === usageType && !uu.archivedDate) ?? false;
    }
}